import { render, staticRenderFns } from "./LoginForgotPassword.vue?vue&type=template&id=33af1ce8&scoped=true"
import script from "./LoginForgotPassword.vue?vue&type=script&lang=ts"
export * from "./LoginForgotPassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33af1ce8",
  null
  
)

export default component.exports